import Icon from '../../components/Icon.vue'

Icon.register({"brands/avianex":{"width":512,"height":512,"paths":[{"d":"M453.1 32H141.1C102.2 32 64.9 63.2 57.8 101.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480H370.9C409.8 480 447.1 448.8 454.2 410.3L510.9 101.8C517.9 63.2 492.1 32 453.1 32zM394.9 379.3L362.9 392.8 247.5 282.8C232.8 292.8 218.3 302.3 205.8 309.9L227.9 374.1 210 386.8 169.4 325.8 117 277.7 132.7 262.3 190.7 293.4C200 282.9 211.5 270.8 223.5 258.5L203 228.9 134.2 129.1 153 100.2 161.9 95.4 265 207.8 269.9 212.3C289.3 193.5 303.7 179.9 303.7 179.9 311.4 173.4 325.2 177 334.4 187.8 343.4 198.3 345 212.5 337.1 219.1 335.3 220.4 321.6 230.5 301.8 244.7L306.3 252 401.2 371.4 394.9 379.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/avianex.js
// module id = 9rzC
// module chunks = 0